module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section contact-us"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("Contact Us")]), _vm._v(" "), _c('div', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('h4', [_vm._v("Still have questions? We can help!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.verifyEmail()
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "you@email.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "hr2"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "width": "100%",
      "height": "300",
      "frameborder": "0",
      "src": "https://www.google.com/maps/embed/v1/place?key=AIzaSyBbdpihLG0mhf1dlzvs_9WMG5VXKp6Uu2E&q=Space+Needle,Seattle+WA",
      "allowfullscreen": ""
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "section fp-auto-height",
    attrs: {
      "id": "footer"
    }
  }, [_c('app-footer')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Signup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/marker.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Address Details")]), _vm._v(" "), _c('p', [_vm._v("Address line 1")]), _vm._v(" "), _c('p', [_vm._v("Street Details 2")]), _vm._v(" "), _c('p', [_vm._v("More Details 3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mail.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Email Address")]), _vm._v(" "), _c('p', [_vm._v("info@website.com")]), _vm._v(" "), _c('p', [_vm._v("support@website.com")]), _vm._v(" "), _c('p', [_vm._v("admin@website.com")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Telephone")]), _vm._v(" "), _c('p', [_vm._v("+ 1 (800) 000-0001")]), _vm._v(" "), _c('p', [_vm._v("+ 1 (800) 000-0002")]), _vm._v(" "), _c('p', [_vm._v("+ 1 (800) 000-0003")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/clock.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Office Details")]), _vm._v(" "), _c('p', [_vm._v("Mon - Fri 11 - 6 PM")]), _vm._v(" "), _c('p', [_vm._v("Saturday - CLOSED")]), _vm._v(" "), _c('p', [_vm._v("Sunday - CLOSED")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09212117"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactPage.vue
// module id = 74
// module chunks = 0